module.exports = __webpack_public_path__ + "static/media/Jujuy.eab34762.svg";